/* eslint-disable multiline-ternary */
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex'
import 'react-reflex/styles.css'
import LocalQualityCheckImageView from './LocalQualityCheckImageView'
import FieldsInfoContainerD from './FieldsInfoContainer'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import {
  IconButton,
  Button,
  Box,
  Typography,
  Link,
  Tooltip,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit'
import { getUser } from '../../../redux/global'
import { httpsCallable, getFunctions } from '../../../utils/firestoreLite'
import { useLocation, useHistory } from 'react-router-dom'
import { ArrowBack } from 'irmlib/icons'
import { useTranslation } from 'react-i18next'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import * as localGdeTransaction from '../../../services/firestore/localGdeTransactions'
import RestrictImage from '../localRestrictImage.jsx'
import { CenterDivOnScreen, ScreenCover, useTheme } from 'irmlib/styles'
import { makeStyles } from '@material-ui/core'
import * as routePaths from '../../../navigation/routePaths'
import styled from 'styled-components'
// import { getImgFromNats } from '../../../services/nats/localNatsTransactions'
// import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import * as constants from '../../../irmlib/src/common/constants'



const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: '100%',
    minhHeight: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: theme.containerBgColor 

  },
  paneStyle: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    boxSizing: 'border-box',
  },
  paneContentStyle: {
    width: '100%',
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
  },
  paneImgStyle: {
    width: '100%',
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto',
    marginTop: '-60px',
  },
  topActionButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '4px 8px',
    // position: 'relative',
    // marginTop: '-64px',
    // zIndex: 24,
    gap: 2,
  },
  mainHeaderContainer: { 
    display: 'flex', 
    marginTop: '0.2rem', 
    alignItems: 'center', 
    justifyContent: 'space-between' 
  },
  bredCrumContainer: {
    display: 'flex', 
    alignItems: 'center' 
  },
  fullScreenView: {
    inset: '0px',
    height: '100dvh',
    background: theme.palette.routePageBackground,
    margin: '0px',
    maxHeight: '100dvh',
    maxWidth: '100dvw', 
    padding: '0px',
    position: 'fixed',
    width: '100dvw',
    zIndex: '1300'
  }
}))

const MainPannelContainer = styled.div(props => ({
  flex: 1,
  border: '1px solid #aaa',
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 160px)',
  background: 'white',
  justifyContent: props.loadingIsTrue ? 'center' : '',
  alignItems: props.loadingIsTrue ? 'center' : ''

}))

const MainContainer = styled.div(props => ({
  width: '100%',
  minhHeight: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: props.containerBgColor 

}))

const LocalQualityCheck = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()
  const theme = useTheme()
  // const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  const { imageID, imageActivityId, imageRequestId, imageSkpBoxNbr, imageDocId } = location.state || {}
  const [imageData, setImageData] = useState(null)
  const [activityId, setActivityId] = useState(imageActivityId)
  const [requestId, setRequestId] = useState(imageRequestId)
  const [skpBoxNbr, setSkpBoxNbr] = useState(imageSkpBoxNbr)
  const [imgDocID, setImgDocID] = useState(imageDocId)
  const [imgId, setImgId] = useState(imageID)
  const [disableFields, setDisableFields] = useState(false)
  const [imgHistory, setImgHistory] = useState([
    {
      imgId: imageID,
      imgDocID: imageDocId,
      activityId: imageActivityId,
      requestId: imageRequestId,
      skpBoxNbr: imageSkpBoxNbr,
      currentIndex: 0,
    },
  ])
  const [historyIndex, setHistoryIndex] = useState(0)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [snackBarController, setSnackBarController] = useState({
    showSnackBar: false,
    varient: '',
    snackBarText: '',
    countDown: -1,
    isRedirectBox: false
  })
  const [loadingController, setLoadingController] = useState({
    intialLoading: true,
    dataLoading: false
  })
  const userval = getUser()
  const { workerId, district } = userval
  const [swapOrder, setSwapOrder] = useState(() => {
    const saved = localStorage.getItem('swapOrder')
    return saved === 'true'
  })
  const handleSwap = () => setSwapOrder((prev) => !prev)
  const [showBanner, setShowBanner] = useState(false)
  const [blobImageList, setBlobImageList] = useState([])
  const [fullView, SetfullView] = useState(false)
  useEffect(() => {
    localStorage.setItem('swapOrder', swapOrder)
  }, [swapOrder])

  useEffect(() => {
    const channel = new BroadcastChannel('tab-duplicate-checker')
    const currentPath = location.pathname
    const handleMessage = (event) => {
      const { type, path } = event.data
      if (type === 'check' && path === currentPath) {
        channel.postMessage({ type: 'duplicate', path: currentPath })
      }
      if (type === 'duplicate' && path === currentPath) {
        setShowBanner(true)
      }
    }
    channel.onmessage = handleMessage
    channel.postMessage({ type: 'check', path: currentPath })
    return () => {
      channel.close()
    }
  }, [location])

  const fetchImageDataById = async (imageDocId) => {
    const data = await localGdeTransaction.getQcImgData(imageDocId)
    if (!data) return null
    return {
      imageDocId,
      ...data,
    }
  }
  
  const getBlobUrls = (imageUrls = []) => {
    return Promise.all(
      imageUrls.map(async (url) => {
        if (typeof url === 'string' && url.includes('nats')) {
          // const natsUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, url)
          // const natsUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, url)
          const natsUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, url)
          return natsUrl || url
        }
        return url
      })
    )
  }

  const handleHardRedirect = () => {
    history.replace(routePaths.viewQualityCheckImages)
  }
  useEffect(() => {
    // route to quality check list screen  if there is no docID
    if (!imgDocID) {
      handleHardRedirect()
      return
    }
    const fetchInitialImageData = async () => {
      if (imgDocID && !imageData) {
        // setLoading(true)
        setLoadingController(prev => ({ ...prev, intialLoading: true }))

        try {
          const data = await fetchImageDataById(imgDocID)
          if (data) {
            setImageData(data)
            const imageUrls = Array.isArray(data.imgDetails.imgPath) ? data.imgDetails.imgPath : []
            const imageData = await getBlobUrls(imageUrls)
            setBlobImageList(imageData)
          }
        } catch (err) {
          console.log('error while feteching data ->', err)
        } finally {
          // setLoading(false)
          setLoadingController(prev => ({ ...prev, intialLoading: false }))
        }
      }
    }
    fetchInitialImageData()
  }, [])

  useEffect(() => {
    let timmer
    if (snackBarController.countDown === 0) {
      handleHardRedirect()
      return
    }
    if (snackBarController.countDown > 0) {
      // start the count down
      timmer = setTimeout(() => {
        setSnackBarController(prev => ({ ...prev, countDown: prev.countDown - 1 }))
      }, 1000)
    }

    return () => clearTimeout(timmer)
  }, [snackBarController.countDown])

  const handleGoBack = () => {
    history.goBack()
  }

  const handleNext = useCallback(async () => {
    // setLoading(true)
    setLoadingController(prev => ({ ...prev, dataLoading: true }))
    setDisableFields(false)
    // setBusy()
    try {
      const functions = getFunctions()
      const scLocalAssignImageForQC = httpsCallable(
        functions,
        'grpGde-scLocalAssignImageForQC'
      )
      const currentImgId = await localGdeTransaction.getDocIdforImg(imgId)
      const response = await scLocalAssignImageForQC({
        currentImgId: currentImgId,
        districtId: district,
        workerId: workerId,
        activityId: activityId,
      })
      // console.log('cloud function response', response)
      const imgData = response?.data?.imageData
      if (!imgData) {
        setSnackBarController(prev => ({ ...prev, showSnackBar: true, snackBarText: 'No images for QC', isRedirectBox: true, varient: 'warning', countDown: 10 }))
        return
      }
      setImgHistory(prev => {
        let updated = [...prev]
        updated[historyIndex] = {
          ...updated[historyIndex],
          currentIndex,
        }

        // Remove the image if it already exists in imagehistoryarray
        updated = updated.filter(item => item.imgId !== imgData.imgId)

        updated.push({
          imgId: imgData.imgId,
          imgDocID: imgData?.imageDocId,
          activityId: imgData.activityId,
          requestId: imgData.requestId,
          skpBoxNbr: imgData.skpBoxNbr,
          currentIndex: 0
        })
        return updated.length > 100 ? updated.slice(-100) : updated
      })
      setHistoryIndex(i => i + 1)
      setImageData(imgData)
      const imageUrls = Array.isArray(imgData.imgDetails.imgPath) ? imgData.imgDetails.imgPath : []
      const imageData = await getBlobUrls(imageUrls)
      setBlobImageList(imageData)
      setActivityId(imgData.activityId)
      setImgId(imgData.imgId)
      setImgDocID(imgData.imageDocId)
      setRequestId(imgData.requestId)
      setSkpBoxNbr(imgData.skpBoxNbr)
      setCurrentIndex(0)
    } catch (error) {
      console.error('Error calling cloud function:', error)
    } finally {
      // setLoading(false)
      setLoadingController(prev => ({ ...prev, dataLoading: false }))
      // clearBusy()
    }
  }, [])

  const handleLoadingController = useCallback((backDropLoading) => {
    setLoadingController(prev => ({ ...prev, dataLoading: backDropLoading }))
  }, [])

  //   if (historyIndex <= 0) return;
  //   const prevEntry = imgHistory[historyIndex - 1];
  //   setLoading(true);
  //   try {
  //     const data = await fetchImageDataById(prevEntry.imgId);
  //     if (!data) {
  //       console.error('Image not found in Firestore:', prevEntry.imgId);
  //       setLoading(false);
  //       return;
  //     }
  //     setHistoryIndex(i => i - 1);
  //     setImageData(data);
  //     setActivityId(data.activityId);
  //     setImgId(data.imgId);
  //     setRequestId(data.requestId);
  //     setSkpBoxNbr(data.skpBoxNbr);
  //     setCurrentIndex(prevEntry.currentIndex || 0);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handlePrevious = async () => {
    if (historyIndex <= 0) return

    // setLoading(true)
    setLoadingController(prev => ({ ...prev, dataLoading: true }))
    // setBusy()

    try {
      await localGdeTransaction.unlockIfQCNotCompleted(imgDocID)

      const prevEntry = imgHistory[historyIndex - 1]
      const prevId = prevEntry.imgDocID
      const res = await localGdeTransaction.tryLockImage(prevId)

      // Always load the previous image (even if it is locked)
      const data = await fetchImageDataById(prevId)
      const imageUrls = Array.isArray(data.imgDetails.imgPath) ? data.imgDetails.imgPath : []
      const imageData = await getBlobUrls(imageUrls)
      setBlobImageList(imageData)
      if (!data) {
        console.error('Image not found in Firestore:', prevEntry.imgDocID)
        // setLoading(false);
        setLoadingController(prev => ({ ...prev, dataLoading: false }))
        return
      }
      setHistoryIndex(i => i - 1)
      setImageData(data)
      setActivityId(prevEntry.activityId)
      setImgId(prevEntry.imgId)
      setImgDocID(prevEntry.imgDocID)
      setRequestId(prevEntry.requestId)
      setSkpBoxNbr(prevEntry.skpBoxNbr)
      setCurrentIndex(prevEntry.currentIndex)

      // 3) disable fields if prev image is locked or image qc is complete
      if (res.status === 'locked-other') {
        setDisableFields(true)
      } else if (res.status === 'qc-complete') {
        setDisableFields(true)
      } else {
        setDisableFields(false)
      }
    } catch (error) {
      console.error('Error in handlePrevious:', error)
    } finally {
      // setLoading(false)
      // clearBusy()
      setLoadingController(prev => ({ ...prev, dataLoading: false }))
    }
  }

  const imageInfoContainer = useMemo(() => {
    return (
      <div className={classes.paneImgStyle}>
        <LocalQualityCheckImageView
          key={imgDocID}
          blobImageList = {blobImageList}
          activityId={activityId}
          imageData={imageData}
          imgId={imgId}
          imageDocId={imgDocID}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
        />
      </div>
    )
  }, [imgDocID, currentIndex, swapOrder, handleNext, blobImageList])
  
  const fieldsInfoContainer = useMemo(() => (
    <div className={classes.paneContentStyle}>
      <FieldsInfoContainerD
        activityId={activityId}
        imageData={imageData}
        imgId={imgId}
        handleHardRedirect={handleHardRedirect}
        handleNext={handleNext}
        handleLoadingController={handleLoadingController}
        imageDocId={imgDocID}
        disableFields={disableFields}
      />
    </div>
  ), [activityId, imageData, imgId, imgDocID, disableFields, swapOrder, handleNext])

  const leftPane = (
    <ReflexElement flex={swapOrder ? 0.41 : 0.59} minSize={100}>
      <div className={classes.paneStyle}>
        {swapOrder ? fieldsInfoContainer : imageInfoContainer}
      </div>
    </ReflexElement>
  )

  const rightPane = (
    <ReflexElement flex={swapOrder ? 0.59 : 0.41} minSize={100}>
      <div className={classes.paneStyle}>
        {swapOrder ? imageInfoContainer : fieldsInfoContainer}
      </div>
    </ReflexElement>
  )

  const breadcrumbs = [
    <Link
      key="breadcrumb-requestId-label"
      underline='hover'
      onClick={handleGoBack}
      color='primary'
      style={{ cursor: 'pointer', zIndex: 25, position: 'relative' }}
    >
      {t('demo.requestId')}
    </Link>,
    <Link
      key="breadcrumb-requestId-value"
      underline='hover'
      onClick={handleGoBack}
      color='primary'
      style={{ cursor: 'pointer', zIndex: 25, position: 'relative' }}
    >
      {requestId}
    </Link>,
    <Link key="breadcrumb-boxId-label" underline='none' color='inherit'>
      {t('tableColumns.boxId')}
    </Link>,
    <Typography key="breadcrumb-boxId-value" sx={{ color: 'text.primary' }}>{skpBoxNbr}</Typography>,
    <Typography key="breadcrumb-imgId-value" sx={{ color: 'text.primary' }}>{imgId}</Typography>,
  ]

  const BreadCrumbsComponent = () => {
    return (
      <Breadcrumbs separator='›' aria-label='breadcrumb'>
        {breadcrumbs}
      </Breadcrumbs>
    )
  }
  return (
    <>
      {!showBanner ? (
        <MainContainer containerBgColor={theme.palette.routePageBackground} className={fullView ? classes.fullScreenView : ''}>
          <div className={classes.mainHeaderContainer} >
            <div className={classes.bredCrumContainer}>
              <IconButton
                onClick={handleGoBack}
                color='primary'
                sx={{ marginRight: 2, zIndex: 25 }}
              >
                <ArrowBack />
              </IconButton>
              <BreadCrumbsComponent />

            </div>
            <div
              className={classes.topActionButtonContainer}
          >
              <Box
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 10,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 2,
                }}
            >
                <Button
                  sx={{
                    color: '#1975BC',
                    '&:hover': { color: '#1569a8' },
                    textTransform: 'none',
                  }}
                  startIcon={<ArrowBackIosNewIcon />}
                  onClick={handlePrevious}
                  disabled={snackBarController.showSnackBar || loadingController.dataLoading || loadingController.intialLoading || historyIndex <= 0}
              >
                  {t('buttons.previous')}
                </Button>

                <Button
                  sx={{
                    color: '#1975BC',
                    '&:hover': { color: '#1569a8' },
                    textTransform: 'none',
                  }}
                  endIcon={<ArrowForwardIosIcon />}
                  onClick={handleNext}
                  disabled={snackBarController.showSnackBar || loadingController.dataLoading || loadingController.intialLoading}
              >
                  Next
                </Button>
              </Box>

              <Tooltip
                title={swapOrder ? 'Switch to Left View' : 'Switch to Right View'}
            >
                <IconButton
                  onClick={handleSwap}
                  sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.1)',
                    },
                  }}
              >
                  <SwapHorizIcon
                    sx={{
                      fontSize: 40,
                      color: '#1975BC',
                      transform: swapOrder ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease, color 0.3s ease',
                    }}
                />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={fullView ? 'Exit Full Screen' : 'Enter Full Screen'}
            >
                <IconButton
                  onClick={() => SetfullView(prev => !prev)}
                  sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.1)',
                    },
                  }}
              >
                  {fullView ? <FullscreenExitIcon/> : <FullscreenIcon/> }
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <MainPannelContainer
            loadingIsTrue= {loadingController.dataLoading || loadingController.intialLoading}
          >
            {loadingController.dataLoading && (<ScreenCover>
              <CenterDivOnScreen>
                <CircularProgress />
              </CenterDivOnScreen>
            </ScreenCover>)}
            {loadingController.intialLoading
              ? (
                <CircularProgress />)
              : (<ReflexContainer orientation='vertical'>
                {leftPane}
                <ReflexSplitter />
                {rightPane}
              </ReflexContainer>)}
          </MainPannelContainer>

          <Snackbar
            open={snackBarController.showSnackBar}
            onClose={() => setSnackBarController(prev => ({ ...prev, showSnackBar: !prev.showSnackBar }))}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={() => setSnackBarController(prev => ({ ...prev, showSnackBar: false }))}
              severity={snackBarController.varient}
              action={snackBarController.isRedirectBox && <Button onClick={handleHardRedirect}>{ t('buttons.goImmediately') }</Button>}
            // sx={{ width: '100%', fontSize: '1.2rem', padding: '16px' }}
            >
              {<>
                <Typography> {snackBarController.snackBarText} </Typography>
                {snackBarController.isRedirectBox && <Typography variant="body2">{ t('smartCatalogLocal.messages.redirectCountDownMsg', { countDown: snackBarController.countDown }) }</Typography>}
              </>}
            </Alert>
          </Snackbar>
        </MainContainer>
      ) : (
        <>{showBanner === true && <RestrictImage />}</>
      )
      }
    </>
  )
}

export default LocalQualityCheck
